/* ==========================================================================
   Oma Nimitarra "in use" mockups
   --------------------------------------------------------------------------
   Flat illustrations of everyday things (lunch box, bottle, pencil case, pencils, t-shirt)
   drawn in true millimetres, with the customer's stickers placed on them at their
   real size and a magnified bubble next to them. Used by the "Käytössä" view of the product designer.

   OmaSticker.mockup(kind, stickers, opts) -> SVG string
     kind      'school' (lunch box, bottle, pencil case) | 'pencils' (three pencils, for the mini labels)
               | 'clothes' (t-shirt with the label at the neck)
               | 'perhe' (the squirrel family: backpack, cane, lunch box, helmet, sleeve) | 'pulla' (the squirrel with the sweater)
     stickers  [{ svg, w, h, shape }] rendered stickers (render() output, w and h in mm without the bleed)
   OmaSticker.mockupInto(el, kind, stickers, opts) writes the scene into el; the squirrel scenes only redraw their stickers
   when the picture is already there (no flicker while the visitor types).
   ========================================================================== */
(function () {
  'use strict';
  var S = window.OmaSticker;
  if (!S) return;

  var uid = 0;

  // A rendered sticker placed on the scene: centred at (x, y) millimetres, rotated, optionally scaled (for the zoom bubble)
  function place(st, x, y, rot, k) {
    if (!st) return '';
    var w = st.w + 1, h = st.h + 1;
    var inner = S.fresh(st.svg).replace('<svg class="sticker"', '<svg width="' + w + '" height="' + h + '" overflow="visible"');
    return '<g transform="translate(' + x + ' ' + y + ') rotate(' + (rot || 0) + ') scale(' + (k || 1) + ')"><g transform="translate(' + (-w / 2) + ' ' + (-h / 2) + ')">' + inner + '</g></g>';
  }
  function pick(list, i) { return list.length ? list[i % list.length] : null; }
  // Scale that makes the sticker span `span` millimetres at most (for the zoom bubbles)
  function fit(st, span, max) { return st ? Math.min(max || 3.2, span / (Math.max(st.w, st.h) + 1)) : 1; }

  var SCENES = {
    // Lunch box, drinking bottle and pencil case on a table, with a magnified bubble. About 340 x 250 mm.
    school: function (st, id, o) {
      var s0 = pick(st, 0), s1 = pick(st, 1), s2 = pick(st, 2);
      return '' +
        '<defs>' +
        '<linearGradient id="' + id + 'b" x1="0" x2="1"><stop offset="0" stop-color="#7CC9E6"/><stop offset=".55" stop-color="#9BD8EE"/><stop offset="1" stop-color="#6FBFDE"/></linearGradient>' +
        '<linearGradient id="' + id + 'l" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#FFEE9A"/><stop offset="1" stop-color="#FFD93D"/></linearGradient>' +
        '<clipPath id="' + id + 'z"><circle cx="46" cy="38" r="28"/></clipPath>' +
        '</defs>' +
        '<ellipse cx="170" cy="238" rx="158" ry="7" fill="#0C4440" opacity=".13"/>' +
        // lunch box
        '<g transform="translate(16 92)">' +
        '<path d="M46 2V-10a10 10 0 0 1 10-10h38a10 10 0 0 1 10 10V2" fill="none" stroke="#0A7F5F" stroke-width="6" stroke-linecap="round"/>' +
        '<rect x="0" y="28" width="152" height="114" rx="14" fill="#FFFFFF" stroke="#0C4440" stroke-opacity=".14" stroke-width="1"/>' +
        '<rect x="0" y="0" width="152" height="38" rx="14" fill="url(#' + id + 'l)"/>' +
        '<rect x="6" y="6" width="140" height="7" rx="3.5" fill="#fff" opacity=".45"/>' +
        '<rect x="0" y="35" width="152" height="6" fill="#0C4440" opacity=".09"/>' +
        '<rect x="32" y="26" width="22" height="20" rx="6" fill="#0A7F5F"/><rect x="98" y="26" width="22" height="20" rx="6" fill="#0A7F5F"/>' +
        '<rect x="36" y="30" width="14" height="4" rx="2" fill="#fff" opacity=".35"/><rect x="102" y="30" width="14" height="4" rx="2" fill="#fff" opacity=".35"/>' +
        place(s0, 30, 92, -5) +
        '</g>' +
        // bottle
        '<g transform="translate(216 14)">' +
        '<rect x="20" y="0" width="40" height="26" rx="9" fill="#0A7F5F"/>' +
        '<rect x="26" y="5" width="6" height="15" rx="3" fill="#fff" opacity=".25"/>' +
        '<rect x="16" y="22" width="48" height="10" rx="4" fill="#0C4440"/>' +
        '<rect x="22" y="30" width="36" height="14" fill="#DCEBFA"/>' +
        '<rect x="0" y="40" width="80" height="182" rx="30" fill="url(#' + id + 'b)"/>' +
        '<rect x="9" y="60" width="10" height="130" rx="5" fill="#fff" opacity=".38"/>' +
        '<rect x="0" y="188" width="80" height="34" rx="30" fill="#0C4440" opacity=".08"/>' +
        place(s1, 42, 120, 3) +
        '</g>' +
        // pencil case in front
        '<g transform="translate(118 190) rotate(-3)">' +
        '<rect x="0" y="4" width="146" height="46" rx="23" fill="#0C4440" opacity=".12"/>' +
        '<rect x="0" y="0" width="146" height="46" rx="23" fill="#F9AEC7"/>' +
        '<rect x="8" y="5" width="130" height="8" rx="4" fill="#fff" opacity=".4"/>' +
        '<path d="M22 13h102" stroke="#fff" stroke-width="2.6" stroke-dasharray="2.4 5.6" stroke-linecap="round" opacity=".85"/>' +
        '<rect x="118" y="8" width="14" height="10" rx="4" fill="#E0578D"/>' +
        place(s2 || s0, 42, 29, 2) +
        '</g>' +
        // zoom bubble: the lunch box sticker, magnified
        '<line x1="46" y1="70" x2="46" y2="172" stroke="#0A7F5F" stroke-width="1.5" stroke-dasharray="3 4" stroke-linecap="round" opacity=".7"/>' +
        '<circle cx="46" cy="38" r="31" fill="#fff" stroke="#0A7F5F" stroke-width="3"/>' +
        '<g clip-path="url(#' + id + 'z)"><rect x="14" y="6" width="64" height="64" fill="#F4F7FB"/>' +
        place(s0, 46, 38, 0, fit(s0, 44)) + '</g>';
    },

    // Three pencils with the mini labels wrapped round them, and a magnified bubble. About 120 x 88 mm (a close-up).
    pencils: function (st, id, o) {
      var s0 = pick(st, 0), s1 = pick(st, 1), s2 = pick(st, 2);
      var ROT = -17;
      function pencil(col, sticker, ox, oy, sx) {
        return '<g transform="translate(' + ox + ' ' + oy + ') rotate(' + ROT + ')">' +
          '<rect x="-13" y="1.1" width="119" height="7" rx="3.4" fill="#0C4440" opacity=".1"/>' +
          '<rect x="-13.5" y="-3.4" width="8" height="6.8" rx="2.3" fill="#F28AB0"/>' +
          '<rect x="-5.8" y="-3.5" width="6.4" height="7" fill="#CBD5E0"/>' +
          '<path d="M-3.9 -3.5V3.5M-1.9 -3.5V3.5" stroke="#8F9BAD" stroke-width=".5"/>' +
          '<rect x="0.6" y="-3.5" width="91.4" height="7" fill="' + col + '"/>' +
          '<rect x="0.6" y="-3.5" width="91.4" height="2.1" fill="#fff" opacity=".3"/>' +
          '<rect x="0.6" y="1.6" width="91.4" height="1.9" fill="#0C4440" opacity=".16"/>' +
          '<path d="M92 -3.5L105 -0.9V0.9L92 3.5Z" fill="#F3D5A6"/>' +
          '<path d="M92 3.5L105 0.9V-0.9L92 -3.5Z" fill="#0C4440" opacity=".07"/>' +
          '<path d="M100 -1.62L106.2 0L100 1.62Z" fill="#39415A"/>' +
          place(sticker, sx, 0, 0) +
          '</g>';
      }
      var zk = fit(s0, 34, 3.4);
      // leader from the bubble to the label on the blue pencil
      var rad = ROT * Math.PI / 180, tx = 16 + 44 * Math.cos(rad), ty = 58 + 44 * Math.sin(rad);
      var dx = tx - 24, dy = ty - 24, len = Math.sqrt(dx * dx + dy * dy);
      var ux = dx / len, uy = dy / len;
      return '' +
        '<defs><clipPath id="' + id + 'z"><circle cx="24" cy="24" r="19.5"/></clipPath></defs>' +
        pencil('#3E63B8', s0, 16, 58, 44) +
        pencil('#F58FB3', s1 || s0, 14, 76, 36) +
        pencil('#4DB977', s2 || s0, 17, 40, 52) +
        // zoom bubble on the first pencil's label
        '<line x1="' + (24 + ux * 22).toFixed(1) + '" y1="' + (24 + uy * 22).toFixed(1) + '" x2="' + (tx - ux * 6).toFixed(1) + '" y2="' + (ty - uy * 6).toFixed(1) + '" stroke="#0A7F5F" stroke-width=".9" stroke-dasharray="2 2.6" stroke-linecap="round" opacity=".7"/>' +
        '<circle cx="24" cy="24" r="21.5" fill="#fff" stroke="#0A7F5F" stroke-width="1.6"/>' +
        '<g clip-path="url(#' + id + 'z)"><rect x="2" y="2" width="44" height="44" fill="#F4F7FB"/>' +
        '<g transform="translate(24 24) scale(' + zk.toFixed(3) + ')">' +
        '<rect x="-30" y="-3.5" width="60" height="7" fill="#3E63B8"/><rect x="-30" y="-3.5" width="60" height="2.1" fill="#fff" opacity=".3"/><rect x="-30" y="1.6" width="60" height="1.9" fill="#0C4440" opacity=".16"/>' +
        place(s0, 0, 0, 0) + '</g></g>';
    },

    // T-shirt with the iron-on label at the back neck and a zoom bubble. About 340 x 250 mm.
    // opts.shirt / opts.shirt2 / opts.collar colour the shirt (white by default).
    clothes: function (st, id, o) {
      var s0 = pick(st, 0);
      var c1 = o.shirt || '#FFFFFF', c2 = o.shirt2 || '#EDF2F8', collar = o.collar || '#D5E1EF';
      return '' +
        '<defs>' +
        '<clipPath id="' + id + 'z"><circle cx="266" cy="178" r="56"/></clipPath>' +
        '<linearGradient id="' + id + 't" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="' + c1 + '"/><stop offset="1" stop-color="' + c2 + '"/></linearGradient>' +
        '</defs>' +
        '<ellipse cx="150" cy="240" rx="120" ry="6" fill="#0C4440" opacity=".1"/>' +
        '<path d="M100 22C114 40 136 48 150 48S186 40 200 22L262 46L300 108L256 130L238 104V226H62V104L44 130L0 108L38 46Z" fill="url(#' + id + 't)" stroke="#0C4440" stroke-opacity=".12"/>' +
        '<path d="M100 22C114 40 136 48 150 48S186 40 200 22L204 32C190 56 168 66 150 66S110 56 96 32Z" fill="' + collar + '"/>' +
        '<path d="M96 32C110 56 132 66 150 66S190 56 204 32" fill="none" stroke="#0C4440" stroke-opacity=".16" stroke-width="1.2" stroke-dasharray="3 3"/>' +
        '<path d="M62 104L44 130M238 104L256 130" stroke="#0C4440" stroke-opacity=".1" stroke-width="1"/>' +
        place(s0, 150, 82, 0) +
        // zoom bubble
        '<line x1="150" y1="82" x2="222" y2="146" stroke="#0A7F5F" stroke-width="1.6" stroke-dasharray="3 4" stroke-linecap="round" opacity=".7"/>' +
        '<circle cx="266" cy="178" r="59" fill="#fff" stroke="#0A7F5F" stroke-width="3"/>' +
        '<g clip-path="url(#' + id + 'z)"><rect x="200" y="120" width="130" height="120" fill="#F4F7FB"/>' +
        '<rect x="200" y="120" width="130" height="18" fill="#D5E1EF"/>' +
        place(s0, 266, 178, 0, 3.2) + '</g>';
    }
  };

  var VIEWBOX = { school: '0 0 340 250', pencils: '0 0 120 88', clothes: '-6 -6 340 256' };

  /* ---------- The squirrels (Vate's own drawings, cut out of the old shop banners) ----------------------------------
     The small labels that were drawn on their things are removed from the pictures; the visitor's own stickers are
     drawn there instead, with an ink outline like the drawings, plus a magnified bubble. Coordinates are picture pixels. */
  var ORAVA = {
    perhe: {
      w: 1297, h: 663, src: 'oravaPerhe',
      anchors: {
        reppu:  { x: 217,    y: 624,   rot: 0,   bw: 48, bh: 48, pref: 'round' },
        keppi:  { x: 671,    y: 574,   rot: 86,  bw: 52, bh: 22, pref: 'oblong' },
        hiha:   { x: 592.5,  y: 430,   rot: 16,  bw: 32, bh: 21, pref: 'oblong' },
        eva1:   { x: 955.5,  y: 499,   rot: -8,  bw: 24, bh: 27, pref: 'square' },
        eva2:   { x: 1001.5, y: 530,   rot: -12, bw: 28, bh: 25, pref: 'square' },
        kypara: { x: 1097.5, y: 381.5, rot: -3,  bw: 28, bh: 24, pref: 'mini' }
      },
      bubble: { x: 1185, y: 118, r: 104, anchor: 'eva2' }
    },
    pulla: {
      w: 747, h: 655, src: 'oravaPulla',
      anchors: { kaula: { x: 492, y: 360, rot: -11, bw: 58, bh: 36, pref: 'oblong' } },
      bubble: { x: 612, y: 128, r: 112, anchor: 'kaula' }
    }
  };
  var INK = '#1B120F', INK_PX = 3.4;

  // The sticker that suits an anchor: the one of the preferred shape if the scene got several shapes, else the first
  function forAnchor(list, a, i) {
    if (list.length < 2) return list[0] || null;
    for (var j = 0; j < list.length; j++) if (list[j].shape === a.pref) return list[j];
    return pick(list, i);
  }

  // A sticker with an ink outline, scaled to fit the box (bw along its long side, bh across), centred at (x, y), rotated
  function boxed(st, x, y, rot, bw, bh, name) {
    if (!st) return '';
    var w = st.w + 1, h = st.h + 1;
    var k = Math.min(bw / w, bh / h);
    var sh = (S.data.SHAPES && S.data.SHAPES[st.shape]) || { kind: 'rect', r: 2.6 };
    var sw = (2 * INK_PX / k).toFixed(3);
    var ink = sh.kind === 'round'
      ? '<circle r="' + (st.w / 2) + '" fill="#fff" stroke="' + INK + '" stroke-width="' + sw + '"/>'
      : '<rect x="' + (-st.w / 2) + '" y="' + (-st.h / 2) + '" width="' + st.w + '" height="' + st.h + '" rx="' + (sh.r || 2.6) + '" fill="#fff" stroke="' + INK + '" stroke-width="' + sw + '" stroke-linejoin="round"/>';
    var inner = S.fresh(st.svg).replace('<svg class="sticker"', '<svg width="' + w + '" height="' + h + '" overflow="visible"');
    return '<g class="orava-label"' + (name ? ' data-anchor="' + name + '"' : '') + ' transform="translate(' + x + ' ' + y + ') rotate(' + (rot || 0) + ') scale(' + k.toFixed(4) + ')">' +
      ink + '<g transform="translate(' + (-w / 2) + ' ' + (-h / 2) + ')">' + inner + '</g></g>';
  }

  function oravaOverlay(def, st, id, bubbleOn) {
    var out = '';
    Object.keys(def.anchors).forEach(function (n, i) { var a = def.anchors[n]; out += boxed(forAnchor(st, a, i), a.x, a.y, a.rot, a.bw, a.bh, n); });
    var b = def.bubble, ba = def.anchors[b.anchor], bs = bubbleOn === false ? null : forAnchor(st, ba, 0);
    if (bs) {
      var dx = ba.x - b.x, dy = ba.y - b.y, len = Math.sqrt(dx * dx + dy * dy), ux = dx / len, uy = dy / len;
      var span = b.r * 1.36;
      out += '<defs><clipPath id="' + id + 'z"><circle cx="' + b.x + '" cy="' + b.y + '" r="' + (b.r - 3) + '"/></clipPath></defs>' +
        '<line x1="' + (b.x + ux * (b.r + 6)).toFixed(1) + '" y1="' + (b.y + uy * (b.r + 6)).toFixed(1) + '" x2="' + (ba.x - ux * 18).toFixed(1) + '" y2="' + (ba.y - uy * 18).toFixed(1) +
        '" stroke="#0A7F5F" stroke-width="3.2" stroke-dasharray="2 9" stroke-linecap="round" opacity=".8"/>' +
        '<circle cx="' + b.x + '" cy="' + b.y + '" r="' + b.r + '" fill="#FFF8EC" stroke="#0A7F5F" stroke-width="6"/>' +
        '<g clip-path="url(#' + id + 'z)">' + boxed(bs, b.x, b.y, 0, span, span) + '</g>';
    }
    return out;
  }

  // The pictures are cut flat at the bottom (the drawings stood behind a banner strip): a strip of ground hides the cut
  function oravaGround(def) {
    var w = def.w, gy = def.h - 9, bottom = def.h + 36;
    return '<path d="M0 ' + (gy + 4) + ' C ' + (w * 0.12).toFixed(0) + ' ' + (gy - 5) + ' ' + (w * 0.25).toFixed(0) + ' ' + (gy + 6) + ' ' + (w * 0.4).toFixed(0) + ' ' + gy +
      ' S ' + (w * 0.62).toFixed(0) + ' ' + (gy - 6) + ' ' + (w * 0.78).toFixed(0) + ' ' + (gy + 3) + ' S ' + (w * 0.93).toFixed(0) + ' ' + (gy - 4) + ' ' + w + ' ' + (gy + 2) +
      ' V ' + bottom + ' H0 Z" fill="#0A7F5F"/>';
  }

  function oravaSvg(kind, st, id, o) {
    var def = ORAVA[kind], NL = window.NL || {};
    var label = (o && o.label) || 'Tarrat käytössä';
    var ground = !(o && o.ground === false);
    var bubbleOn = !(o && o.bubble === false);
    return '<svg class="mockup mockup--' + kind + '" data-id="' + id + '"' + (bubbleOn ? '' : ' data-bubble="0"') + ' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + def.w + ' ' + (def.h + (ground ? 36 : 0)) + '" role="img" aria-label="' + label + '">' +
      '<image href="' + ((NL.assets && NL.assets[def.src]) || '') + '" x="0" y="0" width="' + def.w + '" height="' + def.h + '"/>' +
      (ground ? oravaGround(def) : '') +
      '<g data-overlay>' + oravaOverlay(def, st, id, bubbleOn) + '</g></svg>';
  }

  function oravaReady(kind) { var NL = window.NL || {}; return !!(ORAVA[kind] && NL.assets && NL.assets[ORAVA[kind].src]); }

  S.mockup = function (kind, stickers, opts) {
    stickers = stickers || [];
    if (ORAVA[kind]) {
      if (!oravaReady(kind)) kind = kind === 'pulla' ? 'clothes' : 'school';
      else return oravaSvg(kind, stickers, 'nlm' + (++uid), opts);
    }
    // The pencil close-up only makes sense for labels that fit a pencil (about 7 mm thick)
    if (kind === 'pencils' && stickers.some(function (s) { return s.h > 7; })) kind = 'school';
    if (!SCENES[kind]) kind = 'school';
    var id = 'nlm' + (++uid);
    var label = (opts && opts.label) || 'Tarrat käytössä';
    return '<svg class="mockup mockup--' + kind + '" xmlns="http://www.w3.org/2000/svg" viewBox="' + VIEWBOX[kind] + '" role="img" aria-label="' + label + '">' +
      SCENES[kind](stickers, id, opts || {}) + '</svg>';
  };

  // Writes a scene into an element. The squirrel pictures stay where they are, only the stickers on them are redrawn.
  S.mockupInto = function (el, kind, stickers, opts) {
    if (!el) return;
    stickers = stickers || [];
    if (ORAVA[kind] && oravaReady(kind)) {
      var svg = el.querySelector('svg.mockup--' + kind), g = svg && svg.querySelector('g[data-overlay]');
      if (g) { g.innerHTML = oravaOverlay(ORAVA[kind], stickers, svg.getAttribute('data-id'), svg.getAttribute('data-bubble') !== '0'); return; }
    }
    el.innerHTML = S.mockup(kind, stickers, opts);
  };
})();
